import React, { useState, useEffect, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import useStyles from "../styles";
import Card from "@material-ui/core/Card";
import Overview from "./overview";
import Navbar from "../../navbar_";
import {
  WebContext,
  devConsolelog,
  isEmptyObject,
  getPrivateApi,
  copyToClipWithFormating,
} from "../../../../Utility";
import {
  API_DOMAIN_B2B2C,
  API_RESPONSE_UNAUTHORIZED_STATUS,
  API_SECTION_BOOKING_VERSION,
  API_SECTION_BOOKING_DETAILS,
} from "../../../../Constants";
import TravellerDetail from "./travellerDetail";
import DownloadETicket from "./downloadEticket";
import Call from "@material-ui/icons/Call";
import MailOutline from "@material-ui/icons/MailOutline";
import SubmitFeedback from "./submitFeedback";
import { useTheme } from "@material-ui/core/styles";
const BookingDetail = () => {
  const { code = "" } = useParams();
  const theme = useTheme();
  const classes = useStyles();
  const {
    memberProfile: { phone_numbers = [], emails = [] },
    setViewSnackbar,
    deskTopView = false,
    setOpenDailog,
  } = useContext(WebContext);

  const [bookingData, setBookingData] = useState([]);
  const { state = {} } = useLocation();
  const { finalAuthToken = "", headers = {} } = state;
  const [primaryPh, setPrimaryPh] = useState("");
  const [primaryEmail, setPrimaryEmail] = useState("");

  useEffect(() => {
    if (!isEmptyObject(headers) && finalAuthToken) getBookingData();
  }, [headers, finalAuthToken]);

  useEffect(() => {
    if (phone_numbers.length <= 0) return;
    let [ph = {}] = (phone_numbers || []).filter((phone) => phone.is_primary);
    let { phone_no = "" } = ph || {};
    setPrimaryPh(phone_no);
  }, [phone_numbers]);

  useEffect(() => {
    if (emails.length <= 0) return;
    let [emailId = {}] = (emails || []).filter((email) => email.is_primary);
    let { email = "" } = emailId || {};
    setPrimaryEmail(email);
    devConsolelog("myem", email);
  }, [emails]);

  const getBookingData = async () => {
    let url = `${API_DOMAIN_B2B2C}${API_SECTION_BOOKING_VERSION}${API_SECTION_BOOKING_DETAILS}?code=${code}&type=flight`;

    const {
      data = {},
      err,
      status = null,
    } = await getPrivateApi(url, headers, finalAuthToken);
    if (err && status == API_RESPONSE_UNAUTHORIZED_STATUS) {
      setOpenDailog(true);
      return;
    }
    if (err) {
      devConsolelog("Error fetching booking data:", err);
      setViewSnackbar({
        message: "Failed to load booking details",
        type: "error",
      });
      return;
    }

    if (status >= 200 && status < 300) {
      setBookingData(data);
    } else setViewSnackbar({ message: "Something went wrong!", type: "error" });
  };

  const CallAgent = () => {
    const displayPhone = primaryPh;
    const displayEmail = primaryEmail;
    return (
      <Box
        display={"flex"}
        flexDirection={"column"}
        style={{ marginTop: "8px", padding: 8, flexWrap: "wrap" }}
      >
        <Typography
          style={{ marginBottom: 12, color: theme.agentTheme.card.foreground }}
        >
          For more information please reach out to us:
        </Typography>

        <Box display={"flex"} alignItems={"center"} mb={1}>
          <Call
            style={{
              color: theme?.agentTheme?.primary?.main,
              fontSize: 20,
              marginRight: 12,
            }}
          />
          <Typography
            style={{ color: theme?.agentTheme?.card?.foreground, fontSize: 16 }}
            id={"call"}
            onClick={() => {
              deskTopView &&
                copyToClipWithFormating("call", () =>
                  setViewSnackbar({
                    message: "Phone Number Copied!",
                    type: "success",
                  })
                );
            }}
          >
            {displayPhone}
          </Typography>
        </Box>

        <Box display={"flex"} alignItems={"center"}>
          <MailOutline
            style={{
              color: theme?.agentTheme?.primary?.main,
              fontSize: 20,
              marginRight: 12,
            }}
          />
          <Typography
            style={{ color: theme?.agentTheme?.card?.foreground, fontSize: 16 }}
          >
            {displayEmail}
          </Typography>
        </Box>
      </Box>
    );
  };

  const findLeadPax = (passengerDetail = []) => {
    let leadPassenger = passengerDetail.find((passenger) => {
      let { isleadpax = false } = passenger;
      if (isleadpax) return passenger;
    });
    let { title = "", firstname = "", lastname = "" } = leadPassenger || {};
    let leadPaxname = `${title} ${firstname} ${lastname}`;
    return leadPaxname;
  };
  let {
    itinerary_detail = {},
    passenger_detail = [],
    voucher_url = "",
  } = bookingData;
  let {
    destination = "",
    departure_at = "",
  } = itinerary_detail || {};

  return (
    <>
      <Navbar nonTransparentNav={true} />
      <Box
        style={{ width: "100%", marginTop: "20px",margin:'10px' }}
        className={`${classes.flex} ${classes.justifyCenter}`}
      >
        <Box
          style={{ width: "70%" }}
          className={`${classes.flex} ${classes.gap10} ${classes.justifyCenter} `}
        >
          <Box
            className={`${classes.width70Container}`}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Typography
              variant="h5"
              style={{ color: theme.agentTheme.background.primary_text }}
            >
              Booking Details
            </Typography>
            <Overview
              bookingData={bookingData}
              itineraryData={itinerary_detail}
            />
            <TravellerDetail
              passengerDetail={passenger_detail}
              itineraryData={itinerary_detail}
            />
            {voucher_url && <DownloadETicket voucher_url={voucher_url} />}
          </Box>
          <Box
            className={classes.width30Container}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Card style={{ marginTop: "40px" }} className={classes.rightCards}>
              <Box display={"flex"} alignItems={"center"}>
                {deskTopView ? (
                  <CallAgent />
                ) : (
                  <a
                    href={`tel:${primaryPh}`}
                    style={{ color: theme?.agentTheme?.card?.foreground }}
                  >
                    <CallAgent />
                  </a>
                )}
              </Box>
            </Card>
            <SubmitFeedback
              leadPax={findLeadPax(passenger_detail)}
              travelDate={departure_at}
              destination={destination}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BookingDetail;
